import {materialUrls, material} from './material'
import {hoursUrls, hours} from './hours'

export const serviceUrls = [
  ...materialUrls,
  ...hoursUrls
]

export const service = {
  material,
  hours
}



// WEBPACK FOOTER //
// ./src/api/gip/service/index.js